import {
  allCreditSubscriptionsSelector,
  fetchingSdbCompanyFlagsSelector,
} from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { isFeatureAvailableInCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useEffect, useState } from "react";

interface ReturnProps {
  /** Whether the "Add Credits" button and add credits page should be shown */
  shouldShowAddCredits: boolean;
}

/** Custom hook to determine if the "Add Credits" button and add credits page should be shown */
export function useShouldShowAddCredits(): ReturnProps {
  const isFloorplanGeneratorFeatureEnabled = useAppSelector(
    isFeatureAvailableInCompanySelector("floorplan-generator")
  );
  const { fetchSelectedCompanyContext, isFetchingCompanySubscriptions } =
    useAppSelector(fetchingSdbCompanyFlagsSelector);
  const creditSubscriptions = useAppSelector(allCreditSubscriptionsSelector);

  const [shouldShowAddCredits, setShouldShowAddCredits] = useState(true);

  useEffect(() => {
    if (
      fetchSelectedCompanyContext === "succeeded" &&
      !isFetchingCompanySubscriptions
    ) {
      setShouldShowAddCredits(
        isFloorplanGeneratorFeatureEnabled || creditSubscriptions.length > 0
      );
    }
  }, [
    isFloorplanGeneratorFeatureEnabled,
    fetchSelectedCompanyContext,
    creditSubscriptions.length,
    isFetchingCompanySubscriptions,
  ]);

  return { shouldShowAddCredits };
}
